function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.5 12.66C0.507365 12.9419 0.570323 13.2194 0.685303 13.4769C0.800283 13.7343 0.965003 13.9665 1.16998 14.16C2.40416 15.1316 3.92926 15.6599 5.5 15.6599C7.07074 15.6599 8.59584 15.1316 9.83002 14.16C10.035 13.9665 10.1997 13.7343 10.3147 13.4769C10.4297 13.2194 10.4926 12.9419 10.5 12.66",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.5001 15.66C10.4927 15.9419 10.4297 16.2194 10.3148 16.4769C10.1998 16.7343 10.0351 16.9665 9.83008 17.16",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.16998 17.16C0.965003 16.9665 0.800283 16.7343 0.685303 16.4769C0.570323 16.2194 0.507365 15.9419 0.5 15.66",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.5 6.66003C0.507365 6.94187 0.570323 7.21945 0.685303 7.47687C0.800283 7.73429 0.965003 7.96647 1.16998 8.16003C2.40416 9.13165 3.92926 9.65991 5.5 9.65991C7.07074 9.65991 8.59584 9.13165 9.83002 8.16003C10.035 7.96647 10.1997 7.73429 10.3147 7.47687C10.4297 7.21945 10.4926 6.94187 10.5 6.66003",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.5 6.66003C8.26142 6.66003 10.5 5.31689 10.5 3.66003C10.5 2.00318 8.26142 0.660034 5.5 0.660034C2.73858 0.660034 0.5 2.00318 0.5 3.66003C0.5 5.31689 2.73858 6.66003 5.5 6.66003Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.5 9.66003C0.507365 9.94187 0.570323 10.2194 0.685303 10.4769C0.800283 10.7343 0.965003 10.9665 1.16998 11.16C2.40416 12.1316 3.92926 12.6599 5.5 12.6599C7.07074 12.6599 8.59584 12.1316 9.83002 11.16C10.035 10.9665 10.1997 10.7343 10.3147 10.4769C10.4297 10.2194 10.4926 9.94187 10.5 9.66003",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.5 18.66C0.5 20.32 2.74 21.66 5.5 21.66C8.26 21.66 10.5 20.32 10.5 18.66",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.16992 17.16C2.40409 18.1316 3.9292 18.6599 5.49994 18.6599C7.07068 18.6599 8.59578 18.1316 9.82996 17.16",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.5 18.66V15.66V12.66V9.66003V6.66003V3.66003",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.5 18.66V15.66V12.66V9.66003V6.66003V3.66003",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.5 18.66C12.5074 18.9419 12.5703 19.2194 12.6853 19.4769C12.8003 19.7343 12.965 19.9665 13.17 20.16C14.4042 21.1316 15.9293 21.6599 17.5 21.6599C19.0707 21.6599 20.5958 21.1316 21.83 20.16C22.0349 19.9665 22.1997 19.7343 22.3147 19.4769C22.4297 19.2194 22.4926 18.9419 22.5 18.66",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.5 12.66C12.5074 12.9419 12.5703 13.2194 12.6853 13.4769C12.8003 13.7343 12.965 13.9665 13.17 14.16C14.4042 15.1316 15.9293 15.6599 17.5 15.6599C19.0707 15.6599 20.5958 15.1316 21.83 14.16C22.0349 13.9665 22.1997 13.7343 22.3147 13.4769C22.4297 13.2194 22.4926 12.9419 22.5 12.66",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.5 12.66C20.2614 12.66 22.5 11.3169 22.5 9.66003C22.5 8.00318 20.2614 6.66003 17.5 6.66003C14.7386 6.66003 12.5 8.00318 12.5 9.66003C12.5 11.3169 14.7386 12.66 17.5 12.66Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.5 15.66C12.5074 15.9419 12.5703 16.2194 12.6853 16.4769C12.8003 16.7343 12.965 16.9665 13.17 17.16C14.4042 18.1316 15.9293 18.6599 17.5 18.6599C19.0707 18.6599 20.5958 18.1316 21.83 17.16C22.0349 16.9665 22.1997 16.7343 22.3147 16.4769C22.4297 16.2194 22.4926 15.9419 22.5 15.66",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.5 9.66003V12.66V15.66V18.66",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.5 9.66003V12.66V15.66V18.66",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 23,
  height: 22,
  fill: "white",
  transform: "translate(0 0.160034)"
})));

var SvgNewGivingsHistory = function SvgNewGivingsHistory(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNewGivingsHistory, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/new_givings_history.871394dd.svg";
export { ForwardRef as ReactComponent };